<div class="dialog-container">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{ "objetivos.modificacion.title" | translate }}</h2>
    </div>

    <div mat-dialog-content class="dialog-content">
        <p class="dialog-description">{{ "objetivos.modificacion.description" | translate }}</p>

        <form [formGroup]="formSolicitarModificacion" class="form-container">
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-label>{{ "objetivos.modificacion.motivo.label" | translate }}</mat-label>
                <textarea
                    matInput
                    formControlName="motivo"
                    placeholder="{{ 'objetivos.modificacion.motivo.placeholder' | translate }}"
                    rows="4"
                    [maxlength]="maxLength"
                >
                </textarea>
                <mat-hint align="end">
                    <span [class.text-danger]="caracteresRestantes < 20">
                        {{ caracteresRestantes }} {{ "objetivos.modificacion.motivo.hint" | translate }}
                    </span>
                </mat-hint>
                @if (motivo?.invalid && motivo?.touched) {
                    <mat-error>
                        @if (motivo?.errors?.["required"]) {
                            <span> {{ "objetivos.modificacion.motivo.error.required" | translate }} </span>
                        }
                        @if (motivo?.errors?.["minlength"]) {
                            <span
                                >{{ "objetivos.modificacion.motivo.error.minlength" | translate }} {{ minLength }}
                                {{ "objetivos.caracteres" | translate }}</span
                            >
                        }
                        @if (motivo?.errors?.["maxlength"]) {
                            <span>
                                {{ "objetivos.modificacion.motivo.error.maxlength" | translate }} {{ maxLength }}
                                {{ "objetivos.caracteres" | translate }}</span
                            >
                        }
                    </mat-error>
                }
            </mat-form-field>
        </form>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="onCancel()" class="btn-cancel">
            {{ "objetivos.modificacion.button.cancel" | translate }}
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="onConfirm()"
            [disabled]="!puedeConfirmar"
            class="btn-confirm"
        >
            {{ "objetivos.modificacion.button.confirm" | translate }}
        </button>
    </div>
</div>
